export default __webpack_public_path__ + "static/media/title-background.9e976069.png";